import { VCard } from 'vuetify/lib/components/VCard';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$auth.isAuthenticated && _vm.$auth.loading)?_c(VCard,{staticClass:"fill-height d-flex justify-center align-center pa-4"},[_c('j-loader')],1):(!_vm.$auth.isAuthenticated)?_c('j-error-alert',{attrs:{"value":{ message: 'not authenticated' },"retry-text":"Login"},on:{"retry":function($event){return _vm.login()}}}):_c('router-view')}
var staticRenderFns = []

export { render, staticRenderFns }